<template>
    <div class="content">
      <div class="content-img">
        <van-image :src="require('@/assets/img/successApply.png')"></van-image>
      </div>
      <div class="text-father">
        <p>{{name}}{{sex === 2 ? $t('activity.ms') : $t('activity.mr')}}</p>
        <p class="text-p">{{msg}}</p>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      sex: '',
      activityId: 0,
      msg: ''
    }
  },
  created() {
    if (this.$route.query && this.$route.query.ids) {
      this.activityId = this.$route.query.ids
    }
    this.getUser()
    this.signIn()
  },
  methods: {
    getUser() {
      this.$httpCustApp({
        url: this.$httpCustApp.adornUrl('/wxapp/user/my/jmggInfo'),
        method: 'get',
        params: this.$httpCustApp.adornParams({
          userId: this.$globalData.userInfo.userId,
          orgId: this.$orgId
        })
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.sex = data.userInfoEntity.sex
          this.name = data.userInfoEntity.name
        } else {
          this.$toast.fail(data.msgEn || data.msg)
        }
      })
    },
    signIn() {
      this.$httpCustApp({
        url: this.$httpCustApp.adornUrl(`/wxapp/activity/sign/sign`),
        method: 'post',
        data: this.$httpCustApp.adornParams({
          activityId: this.activityId,
          userId: this.$globalData.userInfo.userId,
          communityId: this.$orgId
        })
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.msg = this.$t('activity.signInOk')
        } else {
          this.msg = data.msgEn || data.msg
        }
      })
    }
  }

}
</script>

<style scoped>
.content {
  height: 10.5rem;
  width: 8rem;
  background-color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 15px;
  padding-top: 50px;
}
.content-img {
  width: 3rem;
  margin: 0 auto;
}
.x-close-dialog {
  font-size: 0.6rem;
  text-align: right;
  padding: 0.3rem 0.4rem 0 0
}
.text-father {
  font-size: 0.5rem;
  font-weight: bold;
  display: inline-block;
  width: 100%;
  text-align: center;
  line-height: 0.8rem;
  margin-top: 0.5rem;
  padding: 0 1rem;
}
.text-p {
  color: red;
  font-size: 0.5rem;
}
</style>
